import { Button, Group } from '@mantine/core';
import { modals } from '@mantine/modals';
import { useState } from 'react';

import { Template } from '@e-origin/shared';

import { useDuplicateTemplate } from '@admin/hooks';
import { TextInput } from '@components';

interface DuplicateTemplateProps {
  template: Template;
}

export const DuplicateTemplate: React.FC<DuplicateTemplateProps> = ({ template }) => {
  const [templateName, setTemplateName] = useState(`DUPL_${template.name}`);
  const duplicateTemplateMutation = useDuplicateTemplate();

  const handleDuplicate = async () => {
    await duplicateTemplateMutation.mutateAsync({
      ...template,
      _id: null,
      createdAt: null,
      updatedAt: null,
      name: templateName,
    });
    modals.closeAll();
  };

  return (
    <>
      <TextInput label="Template name" value={templateName} onChange={(event) => setTemplateName(event.target.value)} />
      <Group justify="center" mt="md">
        <Button type="button" onClick={handleDuplicate} variant="filled" size="lg">
          Duplicate
        </Button>
      </Group>
    </>
  );
};
